import { render, staticRenderFns } from "./NumberPlateInput.vue?vue&type=template&id=5a928edf"
import script from "./NumberPlateInput.vue?vue&type=script&lang=js"
export * from "./NumberPlateInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports